import { simplFileUrl } from '../api/simplApi';

const urlFromType = (type, id) => {
  let url = '';

  switch (type) {
    case 'App\\Staff':
      url = `/staff/${id}`;
      break;
    case 'App\\User':
      url = `/staff/${id}`;
      break;
    case 'App\\Person':
      url = `/person/${id}`;
      break;
    case 'App\\Activity':
      url = `/activity/${id}`;
      break;
    case 'App\\Company':
      url = `/company/${id}`;
      break;
    case 'App\\Project':
      url = `/project/${id}`;
      break;
    case 'App\\NumberRange':
      url = '/numberrange/';
      break;
    case 'App\\ObjectNumber':
      url = '/numberrange/';
      break;
    case 'App\\File':
      url = `${simplFileUrl()}${id}`;
      break;
    case 'App\\Task':
      url = `#task=${id}`;
      break;
    default:
      if (__DEV__) {
        // console.log('no link for', type, id);
      }
  }

  return url;
};

export default urlFromType;



// WEBPACK FOOTER //
// ./src/helpers/urlFromType.js